
import Vue from "vue";
import { FForm, FMessageBox, FRadioGroup, FRadioGroupField } from "@fkui/vue";
import { DinMisstanke, VilkenRoll } from "@/store/types";
import { mapFields } from "vuex-map-fields";
import FkRichtext from "fk-vue-richtext";

export default Vue.extend({
    name: "FkMisstanktForsteg",
    components: {
        FForm,
        FMessageBox,
        FRadioGroup,
        FRadioGroupField,
        FkRichtext,
    },
    data: () => ({
        VilkenRoll,
        DinMisstanke,
    }),
    computed: {
        ...mapFields(["forsteg.misstanke", "forsteg.vilkenroll"]),
    },
    methods: {
        goToNext(): void {
            this.$router.push({
                name: "FkAnmalan",
                params: {
                    tag: "/anmalan",
                },
            });
        },
    },
});
